import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { APIRequest } from '../../../common/Common';
import { getAlertMessageFunction, getTotal, sanitizeList } from '../../../common/Util';
import { TARGET_YEAR_API } from '../../../common/data';
// import { filterNonItemList } from './util';

const initialState = {
  isRender: false,
  reload: -1,
  dataList: [],
  //공제 불가 항목
  nonItemList: [],
  //원본데이터
  originalDataList: [],

  s10Data: {},

  // 주택임차차입금, 장기주택
  s10_1Data: {},
  // 주택마련저축
  s10_2Data: [],
  // 월세액
  s10_3Data: [],

  //만기근로자인지 체크
  workDay: '',

  // 합계
  total: 0,
  //주택자금 상세
  housingFundsDetail: [],

  selectedHousingFundsDetail: {},

  //급여
  salary: 0,
  initMedicalDetail: {},

  checkList1: [],
  detailReload: -1,

  detailData: {},
  detailDataList: [],
};

//주택자금 불러오기
export const getHousingFundsData = createAsyncThunk(
  'housingFunds/getHousingFundsData',
  async () => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S10`);
    return response;
  },
);

// 주택임차차입금, 장기주택
export const getHousingFundsData1 = createAsyncThunk(
  'housingFunds/getHousingFundsData1',
  async () => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S10_1`);
    return response;
  },
);

// 주택마련저축
export const getHousingFundsData2 = createAsyncThunk(
  'housingFunds/getHousingFundsData2',
  async () => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S10_2`);
    return response;
  },
);
// 월세액
export const getHousingFundsData3 = createAsyncThunk(
  'housingFunds/getHousingFundsData3',
  async () => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S10_3`);
    return response;
  },
);

//주택임차차입금 체크
export const getHousingFundsCheck = createAsyncThunk(
  'housingFunds/getHousingFundsCheck',
  async data => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S1010`, data);
    return response;
  },
);

//주택임차차입금, 장기주택, 주택임차 데이터 불러오기
export const getHousingFundsDataDetail = createAsyncThunk(
  'housingFunds/getHousingFundsDataDetail',
  async data => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S1011`, data);
    return { response, data };
  },
);

//월세액 데이터 불러오기
export const getHousingFundsDataDetail4 = createAsyncThunk(
  'housingFunds/getHousingFundsDataDetail4',
  async data => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S1012`, data);
    return { response, data };
  },
);

//주택임차차입금 체크 저장
export const getHousingFundsCheckSave = createAsyncThunk(
  'housingFunds/getHousingFundsCheckSave',
  async data => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S1010E`, data);
    return response;
  },
);

//주택임차차입금  데이터 저장
export const saveHousingFunds = createAsyncThunk('housingFunds/saveHousingFunds', async data => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/S1011E`, data);
  return response;
});

//주택마련저축  데이터 저장
export const saveHousingFunds2 = createAsyncThunk('housingFunds/saveHousingFunds2', async data => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/S1011ES`, data);
  return response;
});

//주택마련저축 데이터 삭제
export const deleteHousingFunds2 = createAsyncThunk(
  'housingFunds/deleteHousingFunds2',
  async data => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S1011D`, data);
    return response;
  },
);

//월세액 데이터 저장
export const saveHousingFunds3 = createAsyncThunk('housingFunds/saveHousingFunds3', async data => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/S1012E`, data);
  return response;
});

//월세액 데이터 삭제
export const deleteHousingFunds3 = createAsyncThunk(
  'housingFunds/deleteHousingFunds3',
  async data => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S1012D`, data);
    return response;
  },
);

const housingFundsSlice = createSlice({
  name: 'housingFundsSlice',
  initialState,
  reducers: {
    confirmDelete: (state, action) => {
      const { index } = action.payload;
      state.dataList = state.dataList.filter((_, idx) => idx !== index);
    },
    setSelectedMedicalDetail: (state, action) => {
      state.selectedMedicalDetail = action.payload;
    },
    setReload: (state, action) => {
      state.reload = Math.random();
    },
    setDetailReload: (state, action) => {
      state.detailReload = Math.random();
    },

    resetHousingFundsState: () => initialState,

    resetCheckList: (state, action) => {
      state.checkList1 = [];
    },

    resetDetailData: (state, action) => {
      state.detailData = {};
      state.detailDataList = [];
    },
  },
  extraReducers: builder => {
    builder.addCase(getHousingFundsData.pending, state => {
      // state.dataList = [];
      // state.nonItemList = [];
      state.isRender = false;
    });
    // 주택자금 리스트
    builder.addCase(getHousingFundsData.fulfilled, (state, action) => {
      console.log('주택자금 리스트 >>', action.payload);
      const { htmJType } = action.payload;
      if (action.payload) {
        state.s10Data = action.payload;
      } else {
        state.s10Data = {};
      }

      state.isRender = true;
    });
    // 주택임차차입금, 장기주택
    builder.addCase(getHousingFundsData1.fulfilled, (state, action) => {
      console.log('주택임차차입금, 장기주택 리스트 >>', action.payload);
      state.s10_1Data =
        {
          ...action.payload,
          total: getTotal([action.payload], ['htm085', 'htm086', 'htm078']),
        } || {};
    });
    // 주택마련저축
    builder.addCase(getHousingFundsData2.fulfilled, (state, action) => {
      console.log('주택마련저축 리스트 >>', action.payload);
      state.s10_2Data = action.payload || [];
    });
    // 월세액
    builder.addCase(getHousingFundsData3.fulfilled, (state, action) => {
      console.log('월세액 리스트 >>', action.payload);
      const { list, workDay } = action.payload;
      if (list) {
        state.s10_3Data = list;
        state.workDay = workDay;
      } else {
        state.s10_3Data = action.payload;
      }
    });
    // 주택임차차입금 체크
    builder.addCase(getHousingFundsCheck.fulfilled, (state, action) => {
      console.log('주택임차차입금 체크 리스트 >>', action.payload);
      const { list, htm013 } = action.payload;
      if (htm013) state.salary = htm013;
      else state.salary = 0;
      if (list) state.checkList1 = list;
      else state.checkList1 = [];
    });
    // 주택임차차입금, 장기저당 체크 저장
    builder.addCase(getHousingFundsCheckSave.fulfilled, (state, action) => {
      console.log('주택임차차입금, 장기저당 체크 저장 리스트 >>', action.payload);
      state.reload = Math.random();
    });
    // 주택임차차입금 상세 리스트
    builder.addCase(getHousingFundsDataDetail.fulfilled, (state, action) => {
      console.log('주택임차차입금 상세 리스트 >>', action.payload);
      const { response, data } = action.payload;
      if (response) {
        if (data.hInType != '3') state.detailData = response || {};
        else state.detailDataList = response || [];
      }
    });
    // 주택임차차입금, 장기주택 저장
    builder.addCase(saveHousingFunds.fulfilled, (state, action) => {
      const { resultCode } = action.payload;
      if (resultCode === 'OK') {
        state.reload = Math.random();
      }
    });
    // 주택마련저축 저장
    builder.addCase(saveHousingFunds2.fulfilled, (state, action) => {
      const { resultCode } = action.payload;
      if (resultCode === 'OK') {
        state.reload = Math.random();
      }
    });
    // 주택마련저축 삭제
    builder.addCase(deleteHousingFunds2.fulfilled, (state, action) => {
      const { resultCode } = action.payload;
      if (resultCode == 'OK') {
        state.detailReload = Math.random();
        state.reload = Math.random();
      }
    });
    // 월세액 상세 리스트
    builder.addCase(getHousingFundsDataDetail4.fulfilled, (state, action) => {
      console.log('월세액 상세 리스트 >>', action.payload);
      const { response, data } = action.payload;
      if (response) {
        state.detailDataList = response || [];
      }
    });
    // 월세액 저장
    builder.addCase(saveHousingFunds3.fulfilled, (state, action) => {
      const { resultCode } = action.payload;
      if (resultCode === 'OK') {
        state.reload = Math.random();
      }
    });
    // 월세액 삭제
    builder.addCase(deleteHousingFunds3.fulfilled, (state, action) => {
      const { resultCode } = action.payload;
      if (resultCode == 'OK') {
        state.detailReload = Math.random();
        state.reload = Math.random();
      }
    });
  },
});

export const {
  confirmDelete,
  resetHousingFundsState,
  setSelectedMedicalDetail,
  setReload,
  setDetailReload,
  resetCheckList,
  resetDetailData,
} = housingFundsSlice.actions;
export default housingFundsSlice.reducer;
